/**
 * Returns the correct backend base URL.
 * On custom domains (arshclub.com etc.), uses same-origin (empty string)
 * to avoid cross-origin cookie issues. On preview, uses the env var.
 */
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

export const getBackendUrl = () => {
  if (typeof window === 'undefined') return envUrl;
  // If current page origin matches the env URL, use it as-is
  if (envUrl && window.location.origin === envUrl) return envUrl;
  // On any other domain (production custom domain), use same-origin
  return window.location.origin;
};

export const BACKEND_URL = getBackendUrl();
